module.exports = __webpack_public_path__ + "media/assets/images/results-6613f07d1775b075edf537de1ac0a05c.svg";